import { handleActions } from 'redux-actions';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  loading: false,
  businessValidationResult: {
    abn: null,
    isCompany: false,
    isTrustee: false,
    isValidated: false,
    isEligible: false,
    message: null,
    mobileNumberFromInvitation: null,
    canVerifyIdUsingPrefilledDetails: false,
  },
};

const reducer = handleActions(
  {
    [actionTypes.UPDATE_BUSINESS_VALIDATION_RESULT]: (state, { payload }) => ({
      ...state,
      businessValidationResult: payload,
    }),
    [actionTypes.RESET_BUSINESS_VALIDATION_RESULT]: (state) => ({
      ...state,
      businessValidationResult: initialState.businessValidationResult,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
